module.exports = __webpack_public_path__ + "img/Speaker=Sabrina Chartrand.6abf894e.png";